import { render } from "./NewsSingle.vue?vue&type=template&id=02a92b03"
import script from "./NewsSingle.vue?vue&type=script&lang=js"
export * from "./NewsSingle.vue?vue&type=script&lang=js"
script.render = render

export default script